import { render, staticRenderFns } from "./AgreementSign.vue?vue&type=template&id=5f8bf45e&scoped=true"
import script from "./AgreementSign.vue?vue&type=script&lang=js"
export * from "./AgreementSign.vue?vue&type=script&lang=js"
import style0 from "./AgreementSign.vue?vue&type=style&index=0&id=5f8bf45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8bf45e",
  null
  
)

export default component.exports